import React from "react";
import Layout from "../components/Layout";
import {
  Container,
  Typography,
  Box,
  Link,
} from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: 5 }}>

        <Typography
          variant="h3"
          gutterBottom
          fontWeight="bold"
          color="primary"
        >
          Privacy Policy
        </Typography>

        <Typography paragraph>
          Your privacy is important to us. It is Practical Pet Parenting's
          policy to respect your privacy regarding any information we may
          collect from you through our website{" "}
          <Link
            href="https://practicalpetparenting.com"
            target="_blank"
            rel="noopener"
          >
            practicalpetparenting.com
          </Link>.
        </Typography>

        <Typography paragraph>
          We only collect personal information when it is necessary to provide
          our services, such as responding to enquiries, nutrition
          consultations, or customer support. Information is collected with your
          knowledge and consent.
        </Typography>

        <Typography paragraph>
          We retain your information only as long as necessary to fulfil the
          purpose for which it was collected and protect it using commercially
          acceptable security measures.
        </Typography>

        <Typography paragraph>
          We do not sell or share your personal information with third parties,
          except where required by law or to operate our website through trusted
          service providers.
        </Typography>

        <Typography paragraph>
          Our website may contain links to external websites. We are not
          responsible for the privacy practices or content of those websites.
        </Typography>

        <Typography paragraph>
          By continuing to use our website, you agree to this Privacy Policy.
          If you have any questions, please contact us using the Contact page.
        </Typography>

        <Box mt={5}>
          <Typography variant="h4" gutterBottom>
            Cookie Policy
          </Typography>

          <Typography paragraph>
            Practical Pet Parenting uses cookies to improve your browsing
            experience and understand how visitors use our website.
          </Typography>

          <Typography variant="h5" gutterBottom>
            What are Cookies?
          </Typography>

          <Typography paragraph>
            Cookies are small text files stored on your device that help improve
            website functionality, remember preferences, and analyse website
            traffic.
          </Typography>

          <Typography variant="h5" gutterBottom>
            How We Use Cookies
          </Typography>

          <ul>
            <li>
              <Typography>
                Remember your website preferences.
              </Typography>
            </li>

            <li>
              <Typography>
                Improve website performance.
              </Typography>
            </li>

            <li>
              <Typography>
                Analyse visitor behaviour using analytics tools.
              </Typography>
            </li>

            <li>
              <Typography>
                Enhance user experience.
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom>
            Managing Cookies
          </Typography>

          <Typography paragraph>
            Most browsers allow you to control or disable cookies through their
            settings. Please note that disabling cookies may affect certain
            features of this website.
          </Typography>

          <Typography variant="h5" gutterBottom>
            Third-Party Services
          </Typography>

          <Typography paragraph>
            We may use trusted third-party services including:
          </Typography>

          <ul>
            <li>
              <Typography>Google Analytics</Typography>
            </li>

            <li>
              <Typography>Google Search Console</Typography>
            </li>

            <li>
              <Typography>Web3Forms (Contact Form Processing)</Typography>
            </li>
          </ul>

          <Typography paragraph>
            These services may use cookies or similar technologies to help us
            improve our website and services.
          </Typography>

          <Typography variant="h5" gutterBottom>
            Your Rights
          </Typography>

          <ul>
            <li>
              <Typography>
                You may request access to, correction of, or deletion of your
                personal information by contacting us through our Contact page.
                We will respond to such requests in accordance with applicable
                law.
              </Typography>
            </li>

            <li>
              <Typography>
                This website is not intended for individuals under the age of
                18. We do not knowingly collect personal information from
                children.
              </Typography>
            </li>

            <li>
              <Typography>
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page with an updated Effective Date.
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom>
            Contact Us
          </Typography>

          <Typography paragraph>
            If you have questions regarding this Privacy Policy, please contact
            us through our Contact page.
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            mt={4}
          >
            Effective Date: 28 June 2026
          </Typography>

        </Box>

      </Container>
    </Layout>
  );
};

export default PrivacyPolicy;